module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_tutuji-ac4b08b8873401ca5c00a4a65b8aab29.png";